import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`負責中台服務之規劃、進度、發佈，並協調外部配合團隊及資源運用等事宜`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      